import React from 'react';
import { FieldWrapper } from './FieldWrapper';
import { Grid } from '@mui/material';

interface ConsentFieldFormProps {
  company: any;
  consentFormFields: any[];
  formValues: any;
  updateValue: (companyId: string, fieldId: string, value: any, dataType: number) => void;
  classes: any;
}

export const ConsentFieldFormWrapper = React.memo(
  ({ company, consentFormFields, formValues, updateValue, classes }: ConsentFieldFormProps) => {
    return (
      <div className={classes.companyFormContainer}>
        <p className={classes.companyNameText}>{company?.name}</p>
        <Grid container spacing={3}>
          {consentFormFields?.map(field => (
            <Grid item xs={12} lg={6} key={field.id}>
              <FieldWrapper
                field={field}
                value={formValues[company.id]?.[field.id]?.value || ''}
                error={formValues[company.id]?.[field.id]?.error || ''}
                disabled={formValues[company.id]?.[field.id]?.disabled || false}
                onChange={(value, meta) => {
                  updateValue(company?.id, field?.id, value, { ...(meta || {}), dataType: field?.dataType });
                }}
              />
            </Grid>
          ))}
        </Grid>
      </div>
    );
  },
);
